"use strict";

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spread = this && this.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDepsVersion = exports.useVersion = exports.createDeeplyOptimizedCustomizedPropsHook = exports.createMemoizedFnCall = exports.useGetValueRef = exports.useUntypedProperty = void 0;
/* eslint-disable react-hooks/exhaustive-deps */

var react_1 = require("react");

var prop_1 = require("./prop");

var deep_copy_1 = require("./deep-copy");

var objects_1 = require("./objects");

var _1 = require(".");

exports.useUntypedProperty = function (obj) {
  var keys = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    keys[_i - 1] = arguments[_i];
  }

  return react_1.useMemo(function () {
    return prop_1.untypedGetProp.apply(void 0, __spread([obj], keys)); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [obj, JSON.stringify(keys)]);
};

exports.useGetValueRef = function (val) {
  var valRef = react_1.useRef(val);
  valRef.current = val;
  var getValRef = react_1.useRef(function () {
    return valRef.current;
  });
  return getValRef;
};

exports.createMemoizedFnCall = function (finalTransformationFn, memoizationStategy, getDependency) {
  var finalTransormationMemoized = new WeakMap();
  return function (rawValue) {
    var dep = getDependency ? getDependency(rawValue) : rawValue;
    var prevFinalDataRef = react_1.useRef(null);

    if (memoizationStategy === "inside-component") {
      var finalValue_1 = react_1.useMemo(function () {
        return finalTransformationFn(rawValue, prevFinalDataRef.current);
      }, [dep]);
      prevFinalDataRef.current = finalValue_1;
      return finalValue_1;
    }

    if (objects_1.isValidWeakMapKey(dep) && finalTransormationMemoized.has(dep)) {
      var finalValue_2 = finalTransormationMemoized.get(dep);
      prevFinalDataRef.current = finalValue_2;
      return finalValue_2;
    }

    var finalValue = finalTransformationFn(rawValue, prevFinalDataRef.current);
    finalTransormationMemoized.set(dep, finalValue);
    prevFinalDataRef.current = finalValue;
    return finalValue;
  };
};

exports.createDeeplyOptimizedCustomizedPropsHook = function (finalTransformationFn, memoizationStategy, getDependency) {
  return exports.createMemoizedFnCall(function (rawData, previousFinalData) {
    var computed = finalTransformationFn(rawData);
    if (!previousFinalData) return computed;
    return deep_copy_1.getDeeplyOptimizedValue(previousFinalData, computed, function (oldValue, newValue) {
      var areCusto = _1.isCustoClass(oldValue) || _1.isCustoClass(newValue);

      if (!areCusto) return {
        skip: true
      };
      return {
        skip: false,
        leaveOld: false
      };
    });
  }, memoizationStategy, getDependency);
};

exports.useVersion = function (value, avoidVersionIncrement) {
  var keyRef = react_1.useRef(1);
  var valueRef = react_1.useRef(value);

  if (valueRef.current !== value && !avoidVersionIncrement) {
    keyRef.current++;
  }

  valueRef.current = value;
  return keyRef.current;
};

exports.useDepsVersion = function (deps) {
  var keyRef = react_1.useRef(1);
  var depsRef = react_1.useRef(deps);

  if (depsRef.current !== deps && depsAreShalowlyEqual(depsRef.current, deps)) {
    keyRef.current++;
  }

  depsRef.current = deps;
  return keyRef.current;
};

var depsAreShalowlyEqual = function depsAreShalowlyEqual(prev, next) {
  if (prev.length !== next.length) return false;

  for (var i = 0; i < prev.length; i++) {
    if (prev[i] !== next[i]) {
      return false;
    }
  }

  return true;
};